import React, { useContext } from "react";
import { Segment, Button, Icon } from "semantic-ui-react";
import ListResolutions from "./ListResolutions";
import BreadcrumbContainer from "../../../../app/common/breadcrumb/BreadcrumbContainer";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import { observer } from "mobx-react-lite";

interface IProps {
  sections: any[];
}


const DashboardResolutions: React.FC<IProps> = ({ sections }) => {
  const rootStore = useContext(RootStoreContext);
  const { syncResolutions, btSyncResolution } = rootStore.resolutionStore;
  document.title = "Resoluciones facturación electrónica";
  return (
    <div className="configurationContent">
      <BreadcrumbContainer
        title="Resoluciones facturación electrónica"
        sections={sections}
      />
      <Segment padded="very">
        <Button
          loading={btSyncResolution}
          disabled={btSyncResolution}
          onClick={() => syncResolutions()}
          color="blue"
        >
          <Icon name="sync alternate" /> Sincronizar
        </Button>
        <br />
        <br />
        <ListResolutions />
      </Segment>
    </div>
  );
};

export default observer(DashboardResolutions);
